import { useAppInfoStore } from 'store'
import { useChangeLanguage } from 'store'

import '@/styles/app-context.scss'

export const AppContext = defineComponent({
  setup(_, { slots }) {
    const appInfoStore = useAppInfoStore()

    useChangeLanguage(appInfoStore.fetchAppInfo)

    return () => (
      <div id="app-context" class={'app-context'}>
        {slots.default?.()}
      </div>
    )
  },
})
